import React from 'react';
import showrunnerLogo from '../assets/images/SHOWRUNNER.png';

/**
 * Default show cover image
 */
function ShowImagePlaceholder({ className = '' }) {
  return (
    <div
      className={`relative w-full bg-white overflow-hidden flex items-center justify-center aspect-[16/10] max-h-[390px] min-h-[200px] md:min-h-[260px] px-[18%] sm:px-[22%] md:px-[28%] py-8 md:py-12 ${className}`}
    >
      <img
        src={showrunnerLogo}
        alt=""
        className="h-full w-full max-h-full object-contain object-center opacity-[0.42] pointer-events-none select-none"
        aria-hidden
      />
    </div>
  );
}

export default ShowImagePlaceholder;
